var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutPlanetOrbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_221_4",
    x1: 365,
    y1: 65,
    x2: 835,
    y2: 535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D43D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DE8A33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.69 179.593C869 292.713 830.245 437.348 717.125 502.658C604.005 567.968 459.37 529.213 394.06 416.093L803.69 179.593Z",
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "orbitPath",
    opacity: 0.25,
    d: "M1023.92 55.2501C1059.42 116.738 898.371 276.114 664.25 411.284C430.129 546.454 211.581 606.238 176.081 544.75C140.581 483.262 301.629 323.886 535.75 188.716C769.871 53.5458 988.419 -6.23772 1023.92 55.2501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "moon",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#fab546"
  }), /*#__PURE__*/React.createElement("path", {
    className: "moon2",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#fab546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "planet",
    d: "M600 535C729.787 535 835 429.787 835 300C835 170.213 729.787 65 600 65C470.213 65 365 170.213 365 300C365 429.787 470.213 535 600 535Z",
    fill: "url(#paint0_linear_221_4)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M1023.92 55.2501C1059.42 116.738 898.371 276.114 664.25 411.284C430.129 546.454 211.581 606.238 176.081 544.75C140.581 483.262 301.629 323.886 535.75 188.716C769.871 53.5458 988.419 -6.23772 1023.92 55.2501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "moon",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#fab546"
  }), /*#__PURE__*/React.createElement("path", {
    className: "moon2",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#fab546"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPlanetOrbit);
export default __webpack_public_path__ + "static/media/about_planet_orbit.e3afb255.svg";
export { ForwardRef as ReactComponent };